import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useGetCurrenciesFromCountry } from '../../hooks/useGetCurrencies';
import { REQUESTING_PLATFORM_TO_CODES } from '../../constants/requesting-platform';
import { getCurrenciesForPlatform } from '../../constants/requesting-platform-currencies';
import { CURRENCY_PILL_SELECT_CLASS_NAME } from '../../theme/constants/select';
import CURRENCY_FLAGS from '../../constants/currency-flags';

const CurrencyPillSelect = ({ currency, setCurrency, requestingPlatform }) => {
  const countryCurrencies = useGetCurrenciesFromCountry().map((c) => c.isoCode);
  const availableCurrencies = getCurrenciesForPlatform(requestingPlatform, countryCurrencies);

  useEffect(() => {
    if (!currency && availableCurrencies.length) {
      setCurrency(availableCurrencies[0]);
    }
  }, [currency, availableCurrencies, setCurrency]);

  return (
    <Box sx={{
      width: 123,
      height: 32,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'text.highlight',
      borderRadius: '20px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
    }}
    >
      <Select
        value={currency}
        onChange={(event) => setCurrency(event.target.value)}
        variant="standard"
        disableUnderline
        IconComponent={KeyboardArrowDown}
        className={CURRENCY_PILL_SELECT_CLASS_NAME}
        renderValue={(value) => {
          const FlagIcon = CURRENCY_FLAGS[value];
          return (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              {FlagIcon && <FlagIcon />}
              <Typography variant="small_3" color="common.black">{value}</Typography>
            </Stack>
          );
        }}
      >
        {availableCurrencies.map((isoCode) => {
          const FlagIcon = CURRENCY_FLAGS[isoCode];
          return (
            <MenuItem key={isoCode} value={isoCode}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                {FlagIcon && <FlagIcon />}
                <Typography variant="small_3">{isoCode}</Typography>
              </Stack>
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

CurrencyPillSelect.propTypes = {
  currency: PropTypes.string,
  setCurrency: PropTypes.func.isRequired,
  requestingPlatform: PropTypes.oneOf(Object.values(REQUESTING_PLATFORM_TO_CODES)).isRequired,
};

CurrencyPillSelect.defaultProps = {
  currency: '',
};

export default CurrencyPillSelect;
